  'use client';

  import React from 'react';

  interface StatusBadgeProps {
    status: string;
  }

  const statusDotColor: Record<string, string> = {
    Pending: 'bg-orange-400',
    Completed: 'bg-green-500',
    Processing: 'bg-blue-500',
    Cancelled: 'bg-red-500',
    Dispatch: 'bg-purple-500',
  };

  const statusTextColor: Record<string, string> = {
    Pending: 'text-orange-500',
    Completed: 'text-green-600',
    Processing: 'text-blue-500',
    Cancelled: 'text-red-500',
    Dispatch: 'text-purple-600',
  };

  export const StatusBadge: React.FC<StatusBadgeProps> = ({ status }) => {
    const dotColor = statusDotColor[status] ?? 'bg-gray-400';
    const textColor = statusTextColor[status] ?? 'text-gray-500';

    return (
      <div className="flex items-center gap-1.5">
        <div className={`w-2 h-2 rounded-full ${dotColor}`}></div>
        <span className={`text-sm font-medium ${textColor}`}>
          {status}
        </span>
      </div>
    );
  };
